<template>
  <label>{{ translate(`${LOCALE_PREFIX}.form.tenders.taxExempt`) }}</label>
  <SelectButtonField
    :id="`tender-tax-exempt-${planType}-${index}`"
    :name="fieldName"
    :options="taxExemptOptions"
    optionLabel="label"
    optionValue="value"
    :unselectable="false"
    :disabled="isDisabled"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../enums';
import { useMealPlan } from '../../meal-plan/composables';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  planType: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set meal plan composable
const { taxExemptOptions } = useMealPlan();
</script>
